import { render, staticRenderFns } from "./ManyStart.vue?vue&type=template&id=ddbfa318"
import script from "./ManyStart.vue?vue&type=script&lang=ts"
export * from "./ManyStart.vue?vue&type=script&lang=ts"
import style0 from "./ManyStart.vue?vue&type=style&index=0&id=ddbfa318&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports